import React, { useState } from "react";

const Leadmagnet = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
    numberOfEmployees: "",
  });

  const [downloadUrl, setDownloadUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage("");
    setDownloadUrl("");

    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.phone
    ) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    setLoading(true);

    const requestBody = {
      Company: formData.company,
      Last_Name: formData.lastName,
      First_Name: formData.firstName,
      Email: formData.email,
      Mobile: formData.phone,
      Phone: formData.phone,
      Lead_Status: "Lead",
      Lead_Source: "NxaTel App",
      Resource_Id: "v92io815dc704e55c4847bef1d58cc2b5b9cc",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_DOMAIN}create-lead-magnet-zoho-api`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();

      if (result.ResponseCode === "1") {
        setDownloadUrl("/assets/pdfs/Start-Smart-Kit.pdf");
        setFormData({
          firstName: "",
          lastName: "",
          company: "",
          email: "",
          phone: "",
          numberOfEmployees: "",
        });
        setShowPopup(true);
      } else {
        setErrorMessage(
          result.ResponseText || "Lead creation failed. Please try again."
        );
      }
    } catch (error) {
      setErrorMessage(error.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    setShowPopup(false);
  };

  return (
    <>
      <div className="starter-kit__header">
        Starter Kit ready to help your business start right
      </div>
      <section className="starter-kit">
        <div className="starter-kit__container">
          <div className="starter-kit__left">
            <img
              src="./../assets/images/StartSmart/smart-start-kit-download.webp"
              alt="Downloadable startup toolkit for business communication"
              className="starter-kit__logo"
            />
          </div>

          <div className="starter-kit__right">
            <h3 className="starter-kit__form-title">
              Download the smart starter Kit and start right
            </h3>
            <p className="starter-kit__form-subtitle">
              Everything you need before printing business cards and submitting
              your proposal.
            </p>

            <form className="starter-kit__form" onSubmit={handleSubmit}>
              <div className="starter-kit__name-row">
                <input
                  type="text"
                  placeholder="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </div>
              <input
                type="text"
                placeholder="Name of the business"
                name="company"
                value={formData.company}
                onChange={handleInputChange}
              />
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              <input
                type="tel"
                placeholder="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />

              <button
                type="submit"
                className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--16-0 pt--10 pb--10 pr--20 pl--20"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Download Free Starter Kit"}
              </button>
            </form>

            {errorMessage && <p className="error-message">{errorMessage}</p>}
          </div>
        </div>
      </section>

      {/* Success Popup */}
      {showPopup && (
        <div className="popup">
          <div className="popup__card">
            <div className="popup__icon">
              <div className="popup__checkmark">&#10003;</div>
            </div>
            <h3 className="popup__title">
              Successful, your download is ready!
            </h3>
            <p className="popup__message">
              Thanks for signing up for our e-book. You will receive an e-book
              by e-mail in a few minutes.
            </p>
            <div className="popup__actions">
              <button className="popup__dismiss" onClick={handleDismiss}>
                Dismiss
              </button>
              <a
                className="popup__download"
                href={downloadUrl}
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                View download
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Leadmagnet;
